export default __webpack_public_path__ + "static/teamPhoto7-8179ca1a03d21ecb627c0b61c1c65b2c.png";